import { render } from "./readPage.vue?vue&type=template&id=56001332"
import script from "./readPage.vue?vue&type=script&lang=js"
export * from "./readPage.vue?vue&type=script&lang=js"

import "./readPage.vue?vue&type=style&index=0&id=56001332&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__